import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { ImportClientValidation } from "@domain/models/ImportClientValidation";

type Input = Client[];

type Output = Promise<ImportClientValidation[]>;

export class ValidateClientImport implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ImportRepository) {}

  execute(clients: Input) {
    return this.clientRepository.validateImport(clients);
  }
}
